import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { IGeolocationEvent } from 'src/app/interface/geolocation-event';

@Injectable({
	providedIn: 'root'
})
export class GeolocationEvent {

	private subject: Subject<IGeolocationEvent>;

	constructor() {
		this.subject = new Subject<IGeolocationEvent>();
	}

	public listener(): Observable<IGeolocationEvent> {
		return this.subject.asObservable();
	}

	public store(value: IGeolocationEvent) {
		this.subject.next(value);
	}
}